/**
 * Text-length limits shared by the API schemas and both clients' inputs
 * (same single-source pattern as COMMENT_LIMITS). Clients enforce these
 * as input maxLength so users can never type into a 400; the API schemas
 * are the backstop.
 */
export const TEXT_LIMITS = {
  GROUP_NAME_MAX: 100,
  GROUP_DESCRIPTION_MAX: 200,
  EXPENSE_TITLE_MAX: 100,
  EXPENSE_NOTES_MAX: 200,
} as const;
